import { render, staticRenderFns } from "./ChecklistTextInputImprove.vue?vue&type=template&id=d3ba3960&"
import script from "./ChecklistTextInputImprove.vue?vue&type=script&lang=js&"
export * from "./ChecklistTextInputImprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
